<app-header></app-header>
<ion-content class="main-content  update-list-wrap" scrollY="true">
  <ion-row>
    <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
      <ion-toolbar mode="md">
        <ion-buttons slot="start">
          <ion-back-button defaultHref="/home"></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title" slot="start">{{'updatedproductlist' | language:'Updated Product List'}}</ion-title>
      </ion-toolbar>
    </ion-col>
  </ion-row>
  <ion-item lines="none">
    <ion-searchbar [debounce]="500" search-icon="search-outline" mode="md" show-clear-button="focus"
      placeholder="{{'search' | language:'Search'}}" (ionInput)="filterProducts($event)">
    </ion-searchbar>
  </ion-item>
  <div class="table-responsive ">
    <table class="ion-table">
      <thead>
        <tr>
          <th (click)="sortTable('ProductId')">
            {{ 'productid' | language:'Product ID' }}
            <ion-icon [name]="sortColumn === 'ProductId' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'ProductId'">
            </ion-icon>
          </th>
          <th (click)="sortTable('ProductName')">
            {{ 'productname' | language:'Product Name' }}
            <ion-icon [name]="sortColumn === 'ProductName' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'ProductName'">
            </ion-icon>
          </th>
          <th>
            {{ 'iconimage' | language:'Icon Image' }}
          </th>
          <th (click)="sortTable('Category')">
            {{ 'category' | language:'Category' }}
            <ion-icon [name]="sortColumn === 'Category' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'Category'">
            </ion-icon>
          </th>
          <th (click)="sortTable('SubCategory')">
            {{ 'subcategory' | language:'Sub Category' }}
            <ion-icon [name]="sortColumn === 'SubCategory' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'SubCategory'">
            </ion-icon>
          </th>
          <th (click)="sortTable('SoldBy')">
            {{ 'soldby' | language:'Sold By' }}
            <ion-icon [name]="sortColumn === 'SoldBy' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'SoldBy'">
            </ion-icon>
          </th>
          <th (click)="sortTable('MinimumQty')">
            {{ 'minimumqty' | language:'Minimum Qty' }}
            <ion-icon [name]="sortColumn === 'MinimumQty' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'MinimumQty'">
            </ion-icon>
          </th>
          <th (click)="sortTable('SellingPrice')">
            {{ 'sellingprice' | language:'Price' }}
            <ion-icon [name]="sortColumn === 'SellingPrice' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'SellingPrice'">
            </ion-icon>
          </th>
          <th (click)="sortTable('ProductStatus')">
            {{ 'availability' | language:'Availability' }}
            <ion-icon [name]="sortColumn === 'ProductStatus' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'ProductStatus'">
            </ion-icon>
          </th>
          <th (click)="sortTable('Grading')">
            {{ 'grading' | language:'Grading' }}
            <ion-icon [name]="sortColumn === 'Grading' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'Grading'">
            </ion-icon>
          </th>
          <th (click)="sortTable('PreOrderDiscount')">
            {{ 'preorderdiscount' | language:'Pre order %' }}
            <ion-icon [name]="sortColumn === 'PreOrderDiscount' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'PreOrderDiscount'">
            </ion-icon>
          </th>
          <th (click)="sortTable('Status')">
            {{ 'status' | language:'Status' }}
            <ion-icon [name]="sortColumn === 'Status' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'Status'">
            </ion-icon>
          </th>
          <th (click)="sortTable('ResponseMessage')">
            {{ 'responsemessage' | language:'Response Message' }}
            <ion-icon [name]="sortColumn === 'ResponseMessage' && sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'"
              *ngIf="sortColumn === 'ResponseMessage'">
            </ion-icon>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!dataSource || dataSource.length === 0" class="no-data-message">
          <td colspan="13" class="ion-text-center">
            {{'Noproductsavailabletodisplay' | language:'No products available to display.'}}
          </td>
        </tr>
        <ng-container *ngIf="dataSource && dataSource.length > 0">
          <tr *ngFor="let product of dataSource">
            <td>{{ product.ProductId }}</td>
            <td>{{ product.ProductName }}</td>
            <td>
              <img [src]="product.ProductImage" alt="{{ product.ProductName }}" class="product-image object-cover">
            </td>
            <td>{{ product.Category }}</td>
            <td>{{ product.SubCategory }}</td>
            <td>{{ product.SoldBy }}</td>
            <td>{{ product.MinimumQty !== null ? product.MinimumQty : 'N/A' }}</td>
            <td>{{ product.SellingPrice }}</td>
            <td>
              <div>
                <span class="product-status-layout" [ngClass]="getProductStatusClass(product.ProductStatus)">
                  {{ product.ProductStatus }}
                </span>
              </div>
            </td>
            <td>{{ product.Grading }}</td>
            <td>{{ product.PreOrderDiscount }} %</td>
            <td>
              <div class="res-status-wrap">
                <button class="status-button btn" [ngClass]="getStatusClass(capitalize(product.Updatestatus))">
                  <span>{{ capitalize(product.Updatestatus) }}</span>
                </button>
              </div>
            </td>
            <td>{{ product.Updatereport }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <!-- Pagination Controls -->
  <ion-row class="pagination-controls">
    <ion-col size="6" class="ion-text-start">
      <!-- Page Limit Dropdown -->
      <div class="page-limit-container">
        <label for="page-limit"> {{'Itemsperpage:' | language:'Items per page: '}}</label>
        <select id="page-limit" (change)="updatePageLimit($event)">
          <option *ngFor="let limit of pageLimits" [value]="limit">
            {{ limit }}
          </option>
        </select>
      </div>

    </ion-col>
    <ion-col size="6" class="ion-text-end">
      <span (click)="changePage(currentPage - 1)" class="pagechange-btn">
        <ion-icon name="chevron-back-outline" class="page-move-icon"></ion-icon>
      </span>
      <ion-text>
        {{'Page' | language:'Page'}} {{ currentPage + 1 }} of {{ totalPages }}
      </ion-text>
      <span (click)="changePage(currentPage + 1)" class="pagechange-btn">
        <ion-icon name="chevron-forward-outline" class="page-move-icon"></ion-icon>
      </span>
    </ion-col>
  </ion-row>
</ion-content>